<div class="d-flex justify-content-center " >
    <div class=""  *ngFor="let butterfle of butterfly">
        <img [src]="butterfle.img"  alt="..." class="butimg">
    </div>
</div>